// components/InnerElement.tsx
import React from 'react';
import styled from 'styled-components';
import { Element } from '../../types/types';
import { useTheme } from '../../middleware/ThemeContext';
import { font, Theme } from '../../utils/themes';
import DeleteIcon from '../../assets/icons/DeleteIcon';
import NewCopyIcon from '../../assets/icons/NewCopyIcon';
import { capitalizeFirstLetter, formattedText, formatText, hexToRgba } from '../../utils/helper';
import StyledText from '../StyledComponents/StyledText';
import FormRenderComponent from './FormRender/FormRenderComponent';
import FormsIcon from '../../assets/icons/FormsIcon';
import SearchIcon from '../../assets/icons/SearchIcon';
import NewFormIcon from '../../assets/icons/NewFormIcon';
import SearchQueryIcon from '../../assets/icons/SearchQueryIcon';
import PageSearchIcon from '../../assets/icons/PageSearchIcon';
import MediaIcon from '../../assets/icons/MediaIcon';
import { getElementClassFromProperties } from '../../utils/pageBuilderElementClass';
import { isYoutubeUrl, getYoutubeEmbedUrl } from '../../utils/youtubeHelper';
import PublicDirectoryIcon from '../../assets/icons/PublicDirectoryIcon';
import PublicDirectory from './PublicDirectory';
import SummaryCardComponent from './Summary';
import { Nightlife } from '@mui/icons-material';
import DragIcon from '../../assets/icons/DragIcon';

const InnerElementWrapper = styled.div<{ isSelected?: boolean, theme: Theme, elementType?: string }>`
  border: none;
  padding: ${({ elementType }) => elementType === 'form' || elementType === 'search_query' || elementType === 'media' ? '0px' : '15px 0px'};
  position: relative;
  transition: all 0.2s;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  -webkit-user-drag: element;
  border-radius:${({ elementType }) => elementType === 'form' || elementType === 'search_query' || elementType === 'media' ? '8px' : '0px'};
  
  &:hover {
  border-color: ${props => props.theme.CreateFormTheme.colors.count};
    border-style: dashed;
    border-width: 1px;
    // border-color: ${props => props.theme.CorporateTheme.colors.blueberry};
  }
  
  &.hoverable {
    /* Parent class for toolbar hover */
  }
`;

const FormPlaceholder = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.2s ease;
  cursor: pointer;
  background: transparent;

`;

const FormPlaceholderIcon = styled.div<{ theme: Theme }>`
  width: 70px;
  height: 70px;
  background: ${props => props.theme.CorporateTheme.colors.background};
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormPlaceholderText = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const FormPlaceholderButton = styled.button<{ theme: Theme }>`
  background: #003d82;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-top: 8px;

  &:hover {
    background: #002855;
  }
`;

const SearchQueryPlaceholder = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.2s ease;
  cursor: pointer;
  background: transparent;

`;

const SearchQueryPlaceholderIcon = styled.div<{ theme: Theme }>`
  width: 70px;
  height: 70px;
  background: ${props => props.theme.CorporateTheme.colors.background};
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchQueryPlaceholderText = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SearchQueryPlaceholderButton = styled.button<{ theme: Theme }>`
  background: #003d82;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-top: 8px;

  &:hover {
    background: #002855;
  }
`;

const GeneralPlaceholder = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.2s ease;
  cursor: pointer;
  background: transparent;

`;

const GeneralPlaceholderIcon = styled.div<{ theme: Theme }>`
  width: 70px;
  height: 70px;
  background: ${props => props.theme.CorporateTheme.colors.background};
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const GeneralPlaceholderText = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const GeneralPlaceholderButton = styled.button<{ theme: Theme }>`
  background: #003d82;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-top: 8px;

  &:hover {
    background: #002855;
  }
`;

const MediaPlaceholder = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.2s ease;
  cursor: pointer;
  background: transparent;

`;

const MediaPlaceholderIcon = styled.div<{ theme: Theme }>`
  width: 70px;
  height: 70px;
  background: ${props => props.theme.CorporateTheme.colors.background};
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MediaPlaceholderText = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const MediaPlaceholderButton = styled.button<{ theme: Theme }>`
  background: #003d82;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-top: 8px;

  &:hover {
    background: #002855;
  }
`;

const ElementToolbar = styled.div`
  position: absolute;
  top: -33px;
  right: 0px;
  display: flex;
  z-index: 99;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;

  ${InnerElementWrapper}:hover & {
    opacity: 1;
    pointer-events: all;
  }
`;


const ButtonElement = styled.button<{
  $bgColor: string;
  $textColor: string;
  $hoverColor: string;
  $padding: string;
  $primaryFont?: string;
}>`
  background: ${({ $bgColor }) => $bgColor};
  color: ${({ $textColor }) => $textColor};
  border: none;
  padding: ${({ $padding }) => $padding};
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-family: ${({ $primaryFont }) => $primaryFont || 'inherit'};

  &:hover {
    background-color: ${({ $hoverColor }) => $hoverColor};
  }
`;

const ButtonWrapper = styled.div<{ $alignment?: string }>`
  display: flex;
  justify-content: ${({ $alignment }) => {
    if ($alignment === 'center') {
      return 'center';
    }
    if ($alignment === 'right') {
      return 'flex-end';
    }
    return 'flex-start';
  }};
`;

const ButtonLink = styled.a`
  display: inline-flex;
  text-decoration: none;
`;

// Lazy load SearchQueryRenderer once at module level to prevent remounting
const LazySearchQueryRenderer = React.lazy(() =>
  import('./SearchQueryRenderer').then(module => ({
    default: module.SearchQueryRenderer
  }))
);

const LazyPublicDirectory = React.lazy(async () => ({
  default: PublicDirectory
}));

interface InnerElementProps {
  element: Element;
  selectedElement: string | null;
  setSelectedElement: (id: string | null) => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onOpenSettings: (config: any) => void;
  onHoverChange?: (isHovering: boolean) => void;
  pendingChanges?: Map<string, any>;
  sectionId?: string;
  column: 'left' | 'right' | 'single' | undefined;
  primaryFont?: string;
  onDragStart?: () => void;
  onDragEnd?: () => void;
}

const InnerElement: React.FC<InnerElementProps> = ({
  element,
  selectedElement,
  setSelectedElement,
  onDelete,
  onDuplicate,
  onOpenSettings,
  onHoverChange,
  pendingChanges = new Map(),
  sectionId,
  column,
  primaryFont,
  onDragStart,
  onDragEnd
}) => {
  const { theme } = useTheme();

  const changeKey = sectionId && column
    ? `${sectionId}-${column}-${element.id}`
    : element.id;

  const hasPendingChanges = pendingChanges.has(changeKey);


  // Get the applied settings from pending changes or element properties
  const appliedSettings = hasPendingChanges
    ? pendingChanges.get(changeKey)
    : element.properties || {};


  const mergedElement = {
    ...element,
    ...appliedSettings
  };

  const uniqueElementClass =
    typeof appliedSettings?.elementClass === 'string' && appliedSettings.elementClass.trim()
      ? appliedSettings.elementClass.trim()
      : getElementClassFromProperties(element);
  const typeClass = `${element.type}-element`;


  const renderElementContent = () => {
    // if (element.type === 'heading') {
    //   return (
    //     <StyledText
    //       htmlTag={mergedElement?.heading?.toLowerCase() || 'h1'}
    //       style={{
    //         fontSize: mergedElement?.fontSize ? `${mergedElement.fontSize}px` : '28px',
    //         fontWeight: mergedElement?.fontWeight === "regular" ? 400 : mergedElement?.fontWeight === 'medium' ? 500 : 700,
    //         textAlign: (mergedElement?.textAlignment || 'left') as any,
    //         fontFamily: font.raleway,
    //         color: mergedElement?.color || '#1a3a5c'
    //       }}
    //     >
    //       {appliedSettings?.content || element.content}
    //     </StyledText>
    //   );
    // }
    if (element.type === 'heading') {
      // Use htmlContent from API first, then fall back to content property, then default
      const headingContent = appliedSettings?.htmlContent || appliedSettings?.content || element?.content || 'Heading Goes Here';
      const headingTag = mergedElement?.heading?.toLowerCase() || 'h1';
      
      // Check if content is HTML (contains HTML tags)
      const isHtml = /<[^>]*>/.test(headingContent);
      
      const headingProps = {
        className: `${typeClass} ${uniqueElementClass}`,
        'data-element-id': element.id,
        'data-element-type': element.type,
        style: {
          fontSize: mergedElement?.fontSize
            ? String(mergedElement?.fontSize).includes('px')
              ? mergedElement?.fontSize
              : `${mergedElement?.fontSize}px`
            : '14px',
          fontWeight: mergedElement?.fontWeight === "regular" ? 400 : mergedElement?.fontWeight === 'medium' ? 500 : 700,
          textAlign: (mergedElement?.textAlignment || 'left') as any,
          fontFamily: primaryFont || font.raleway,
          color: mergedElement?.color || '#1a3a5c'
        }
      };
      
      if (isHtml) {
        return React.createElement(headingTag, {
          ...headingProps,
          dangerouslySetInnerHTML: { __html: headingContent }
        });
      } else {
        return React.createElement(headingTag, headingProps, headingContent);
      }
    }
    // if (element.type === 'paragraph') {
    //   return <StyledText htmlTag={'p'} style={{ textAlign: mergedElement?.paragraphTextAlignment || 'left' }} fontWeight={mergedElement?.paragraphFontWeight === "regular" ? 400 : mergedElement?.paragraphFontWeight === 'medium' ? 500 : 700} fontSize={mergedElement?.paragraphFontSize ? `${mergedElement.paragraphFontSize}px` : '14px'}>
    //     {mergedElement?.paragraphContent || element.content}
    //   </StyledText>
    // }
    if (element.type === 'paragraph') {
      const paragraphContent = mergedElement?.htmlContent || mergedElement?.paragraphContent || element?.content || 'This is a paragraph. Add your content here.';
      
      // Check if content is HTML (contains HTML tags)
      const isHtml = /<[^>]*>/.test(paragraphContent);
      
      return isHtml ? (
        <div
          className={`${typeClass} ${uniqueElementClass} ql-editor`}
          data-element-id={element.id}
          data-element-type={element.type}
          style={{
            pointerEvents: 'none',
            // textAlign: mergedElement?.paragraphTextAlignment || 'left',
            fontFamily: primaryFont || font.raleway,
            color: mergedElement?.paragraphColor || '#000000',
            // fontWeight: mergedElement?.paragraphFontWeight === "regular" ? 400 : mergedElement?.paragraphFontWeight === 'medium' ? 500 : 700,
            fontSize: mergedElement?.paragraphFontSize
              ? String(mergedElement.paragraphFontSize).includes('px')
                ? mergedElement.paragraphFontSize
                : `${mergedElement.paragraphFontSize}px`
              : '14px'
          }}
          dangerouslySetInnerHTML={{ __html: paragraphContent }}
        />
      ) : (
        <p
          className={`${typeClass} ${uniqueElementClass}`}
          data-element-id={element.id}
          data-element-type={element.type}
          style={{
            textAlign: mergedElement?.paragraphTextAlignment || 'left',
            fontFamily: primaryFont || font.raleway,
            color: mergedElement?.paragraphColor || '#000000',
            fontWeight: mergedElement?.paragraphFontWeight === "regular" ? 400 : mergedElement?.paragraphFontWeight === 'medium' ? 500 : 700,
            fontSize: mergedElement?.paragraphFontSize
              ? String(mergedElement.paragraphFontSize).includes('px')
                ? mergedElement.paragraphFontSize
                : `${mergedElement.paragraphFontSize}px`
              : '14px'
          }}
        >
          {paragraphContent}
        </p>
      );
    }
    if (element.type === 'separator') {
      return <hr style={{ border: 'none', borderTop: `${mergedElement?.separatorHeight} ${mergedElement?.separatorType || 'solid'} ${mergedElement?.separatorColor}`, margin: '10px 0' }} />
      // <hr style={{ border: 'none', borderTop: `${mergedElement?.separatorHeight} solid ${mergedElement?.separatorColor}`, margin: '10px 0' }} />;
    }
    if (element.type === 'media') {
      const mediaType = mergedElement?.mediaType || 'Image';
      const mediaTypePrefix = mediaType.toLowerCase();

      // Get media URL - priority: signedUrl > preview > externalURL > others
      const mediaUrl = mergedElement?.signedUrl ||
        mergedElement?.[`${mediaTypePrefix}Preview`] ||
        mergedElement?.[`${mediaTypePrefix}ExternalURL`] ||
        mergedElement?.[`${mediaTypePrefix}Url`] ||
        mergedElement?.[`${mediaTypePrefix}URL`];

      const textAlignment = mergedElement?.textAlignment || 'center';
      const caption = mergedElement?.content || '';
      const fontSize = mergedElement?.fontSize || 14;
      const linkURL = mergedElement?.linkURL;
      const openNewTab = mergedElement?.openNewTab;

      // If no media URL, show placeholder
      if (!mediaUrl) {
        return (
          <MediaPlaceholder
            theme={theme}
            onClick={() => {
              onOpenSettings({
                type: 'column-element',
                itemId: element.id,
                itemType: element.type,
                sectionId: sectionId,
                column: column
              });
            }}
          >
            <MediaPlaceholderIcon theme={theme}>
              <MediaIcon />
            </MediaPlaceholderIcon>
            <MediaPlaceholderText>
              <StyledText fontSize="15px" fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                Upload image or video using the media settings menu
              </StyledText>
              <StyledText fontSize="13px" fontWeight={400} textColor="#6c757d">
                The image or video will be previewed here
              </StyledText>
            </MediaPlaceholderText>
            <MediaPlaceholderButton theme={theme}>
              Open Settings
            </MediaPlaceholderButton>
          </MediaPlaceholder>
        );
      }

      const mediaElement = (
        mediaType === 'Image' || mediaType === 'image' ? (
          <img
            src={mediaUrl}
            alt={caption || 'Media'}
            style={{
              maxWidth: '100%',
              maxHeight: '300px',
              borderRadius: '6px',
              display: 'block',
              margin: textAlignment === 'center' ? '0 auto' : textAlignment === 'right' ? '0 0 0 auto' : '0',
              cursor: linkURL ? 'pointer' : 'default'
            }}
          />
        ) : isYoutubeUrl(mediaUrl) ? (
          <iframe
            key={mediaUrl}
            width="560px"
            height="300px"
            src={getYoutubeEmbedUrl(mediaUrl) || mediaUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              maxWidth: '100%',
              borderRadius: '6px',
              display: 'block',
              margin: textAlignment === 'center' ? '0 auto' : textAlignment === 'right' ? '0 0 0 auto' : '0',
              cursor: linkURL ? 'pointer' : 'default'
            }}
          />
        ) : (
          <video
            key={mediaUrl}
            controls
            style={{
              maxWidth: '100%',
              maxHeight: '300px',
              borderRadius: '6px',
              display: 'block',
              margin: textAlignment === 'center' ? '0 auto' : textAlignment === 'right' ? '0 0 0 auto' : '0',
              cursor: linkURL ? 'pointer' : 'default'
            }}
          >
            <source src={mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )
      );

      return (
        <div style={{
          textAlign: textAlignment as any,
          borderRadius: '6px'
        }}>
          {linkURL && mediaUrl ? (
            <a
              href={linkURL}
              target={openNewTab ? '_blank' : undefined}
              rel={openNewTab ? 'noopener noreferrer' : undefined}
              style={{ textDecoration: 'none', display: 'inline-block', width: textAlignment === 'center' ? '100%' : 'auto' }}
            >
              {mediaElement}
            </a>
          ) : (
            mediaElement
          )}
          {/* {caption && (
            <StyledText
              style={{
                fontSize: `${fontSize}px`,
                marginTop: '10px',
                textAlign: textAlignment as any
              }}
            >
              {caption}
            </StyledText>
          )} */}
        </div>
      );
    }
    if (element.type === 'form') {
      // If form has been saved with formId, render the actual form
      if (mergedElement?.formId) {
        return <FormRenderComponent
          formId={mergedElement.formId}
          formName={mergedElement.formName}
        />;
      }
      // Placeholder when no form is selected
      return (
        <FormPlaceholder
          theme={theme}
          onClick={() => {
            onOpenSettings({
              type: 'column-element',
              itemId: element.id,
              itemType: element.type,
              sectionId: sectionId,
              column: column
            });
          }}
        >
          <FormPlaceholderIcon theme={theme}>
            <NewFormIcon color="#0050ff" />
          </FormPlaceholderIcon>
          <FormPlaceholderText>
            <StyledText fontSize="15px" fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
              Attach the form using the form setting menu
            </StyledText>
            <StyledText fontSize="13px" fontWeight={400} textColor="#6c757d">
              The selected form will be previewed here
            </StyledText>
          </FormPlaceholderText>
          <FormPlaceholderButton theme={theme}>
            Open Settings
          </FormPlaceholderButton>
        </FormPlaceholder>
      );
    }
    if (element.type === 'button') {
      const buttonPadding = mergedElement?.buttonSize === 'small'
        ? '8px 20px'
        : mergedElement?.buttonSize === 'large'
          ? '16px 40px'
          : '12px 30px';
      const buttonContent = mergedElement?.content || element.content;
      const buttonAlignment = mergedElement?.buttonAlignment || 'left';
      const buttonBgColor = mergedElement?.buttonColor || '#0050ff';
      const buttonTextColor = mergedElement?.buttonTextColor || '#DDEBFF';
      const buttonHoverColor = mergedElement?.buttonHoverColor || '#003FC7';
      const buttonLink = mergedElement?.buttonLink;
      const openNewTab = mergedElement?.openNewTab;
      const buttonNode = (
        <ButtonElement
          $bgColor={buttonBgColor}
          $textColor={buttonTextColor}
          $hoverColor={buttonHoverColor}
          $padding={buttonPadding}
          $primaryFont={primaryFont}
        >
          {buttonContent}
        </ButtonElement>
      );

      return (
        <ButtonWrapper $alignment={buttonAlignment}>
          {buttonLink ? (
            <ButtonLink
              href={buttonLink}
              target={openNewTab ? '_blank' : undefined}
              rel={openNewTab ? 'noopener noreferrer' : undefined}
            >
              {buttonNode}
            </ButtonLink>
          ) : (
            buttonNode
          )}
        </ButtonWrapper>
      );
    }
    // if (element.type === 'search-query') {
    //   if (mergedElement?.searchQueryId && mergedElement?.scope) {
    //     const SearchQueryRenderer = React.lazy(() =>
    //       import('./SearchQueryRenderer').then(module => ({
    //         default: module.SearchQueryRenderer
    //       }))
    //     );
    //     return (
    //       <React.Suspense fallback={<div>Loading...</div>}>
    //         <SearchQueryRenderer
    //           searchQueryId={String(mergedElement.searchQueryId)}
    //           scope={mergedElement.scope}
    //           searchQueryName={mergedElement.searchQueryName}
    //         />
    //       </React.Suspense>
    //     );
    //   }
    //   return (
    //     <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '6px', textAlign: 'center' }}>
    //       <StyledText fontSize="14px" color="#666">
    //         No search query selected. Configure search query in settings.
    //       </StyledText>
    //     </div>
    //   );
    // }
    if (element.type === 'search_query') {
      if (appliedSettings?.searchQueryId && appliedSettings?.scope) {
        return (
          <React.Suspense fallback={<div>Loading...</div>}>
            <LazySearchQueryRenderer
              searchQueryId={String(appliedSettings.searchQueryId)}
              scope={appliedSettings.scope}
              searchQueryName={appliedSettings.searchQueryName}
              showPagination={false}
            />
          </React.Suspense>
        );
      }
      // Placeholder when no search query is selected
      return (
        <SearchQueryPlaceholder
          theme={theme}
          onClick={() => {
            onOpenSettings({
              type: 'column-element',
              itemId: element.id,
              itemType: element.type,
              sectionId: sectionId,
              column: column
            });
          }}
        >
          <SearchQueryPlaceholderIcon theme={theme}>
            <PageSearchIcon />
          </SearchQueryPlaceholderIcon>
          <SearchQueryPlaceholderText>
            <StyledText fontSize="15px" fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
              Add a search query using the search query settings menu
            </StyledText>
            <StyledText fontSize="13px" fontWeight={400} textColor="#6c757d">
              The search query will be previewed here
            </StyledText>
          </SearchQueryPlaceholderText>
          <SearchQueryPlaceholderButton theme={theme}>
            Open Settings
          </SearchQueryPlaceholderButton>
        </SearchQueryPlaceholder>
      );
    }

    if ((element as any).type === 'public_directory') {
      if (appliedSettings?.scope) {
        const queryPayload = appliedSettings?.queryPayload ?? appliedSettings?.publicDirectoryPayload;
        return (
          <React.Suspense fallback={<div>Loading...</div>}>
            <LazyPublicDirectory 
              key={`${element.id}-${appliedSettings.scope}`} 
              scope={appliedSettings.scope}
              queryPayload={queryPayload}
            />
          </React.Suspense>
        );
      }
      return (
        <GeneralPlaceholder
          theme={theme}
          onClick={() => {
            onOpenSettings({
              type: 'column-element',
              itemId: element.id,
              itemType: element.type,
              sectionId: sectionId,
              column: column
            });
          }}
        >
          <GeneralPlaceholderIcon theme={theme}>
            <PublicDirectoryIcon />
          </GeneralPlaceholderIcon>
          <GeneralPlaceholderText>
            <StyledText fontSize="15px" fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
              Select directory from setting
            </StyledText>
            <StyledText fontSize="13px" fontWeight={400} textColor="#6c757d">
              You can select contact and organization directory from directory settings
            </StyledText>
          </GeneralPlaceholderText>
          <SearchQueryPlaceholderButton theme={theme}>
            Open Settings
          </SearchQueryPlaceholderButton>
        </GeneralPlaceholder>
      );
    }

    if (element.type === "contact_summary" || element.type === "organization_summary") {
      return (
        <SummaryCardComponent
          summaryType={element.type}
          onProfileClick={() => console.log('Go to profile')}
        />
      );
    }
    // if (element.type === "contact_summary") {
    //   return (
    //     <SummaryCardComponent
    //       summaryType="contact_summary"
    //       onProfileClick={() => console.log('Go to profile')}
    //     />
    //   );
    // }
    return null;
  };

  return (
    <InnerElementWrapper
      className='hoverable'
      draggable
      isSelected={selectedElement === element.id}
      onDragStartCapture={(e) => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', `element:${element.id}`);
      }}
      onClick={(e) => {
        e.stopPropagation();
        setSelectedElement(element.id);
      }}
      onDragStart={(e) => {
        e.stopPropagation();
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', `element:${element.id}`);
        onDragStart?.();
      }}
      onDragEnd={(e) => {
        e.stopPropagation();
        onDragEnd?.();
      }}
      onMouseEnter={() => onHoverChange?.(true)}
      onMouseLeave={() => onHoverChange?.(false)}
      theme={theme}
      elementType={element.type}
      data-element-id={element.id}
      data-element-type={element.type}
    >
      {/* <ElementToolbar>
        <ToolbarButton 
          title="Settings"
          onClick={(e) => {
            e.stopPropagation();
            onOpenSettings({
              type: 'column-element',
              itemId: element.id,
              itemType: element.type
            });
          }}
        >
          ⚙️
        </ToolbarButton>
        <ToolbarButton title="Duplicate">📋</ToolbarButton>
        <ToolbarButton
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          title="Delete"
        >
          🗑️
        </ToolbarButton>
      </ElementToolbar> */}
      <ElementToolbar>
        <div style={{ background: theme.CorporateTheme.colors.headerColor, borderRadius: '4px 0px 0 0', display: 'flex', gap: '8px', padding: '6px 12px', alignItems: 'center', justifyContent: 'center' }}>
          <div
            draggable
            onDragStart={(e) => {
              e.stopPropagation();
              e.dataTransfer.effectAllowed = 'move';
              e.dataTransfer.setData('text/plain', `element:${element.id}`);

              const elementNode = (e.currentTarget as HTMLElement).closest('[data-element-id]') as HTMLElement | null;
              if (elementNode) {
                const rect = elementNode.getBoundingClientRect();
                e.dataTransfer.setDragImage(elementNode, e.clientX - rect.left, e.clientY - rect.top);
              }

              onDragStart?.();
            }}
            onDragEnd={(e) => {
              e.stopPropagation();
              onDragEnd?.();
            }}
            className='d-flex align-items-center justify-content-center'
            style={{ cursor: 'grab' }}
          >
            <DragIcon color={theme.CorporateTheme.colors.background} size={20} />
          </div>
          <div style={{ height: 13, width: 1, background: hexToRgba(theme.CorporateTheme.colors.white, 0.16) }} />
          <div
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className='d-flex align-items-center justify-content-center'
          >
            <DeleteIcon color={theme.CorporateTheme.colors.background} size={22} />
          </div>
          {element.type === "contact_summary" || element.type === "organization_summary" ? null : <div style={{ height: 13, width: 1, background: hexToRgba(theme.CorporateTheme.colors.white, 0.16) }} />}
          {element.type === "contact_summary" || element.type === "organization_summary" ? null : <div
            className='d-flex align-items-center justify-content-center'
            onClick={(e) => {
              e.stopPropagation();
              onDuplicate();
            }}
          >
            <NewCopyIcon color={theme.CorporateTheme.colors.background} size={20} />
          </div>}
        </div>

        {element.type === "contact_summary" || element.type === "organization_summary" ? null : <div
          style={{ background: theme.CorporateTheme.colors.count, padding: '6px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '0 4px 0px 0px' }}
          onClick={(e) => {
            e.stopPropagation();
            onOpenSettings({
              type: 'column-element',
              itemId: element.id,
              itemType: element.type,
              sectionId: sectionId,
              column: column
            });
          }}
        >
          <StyledText fontSize='14px' fontWeight={600} textColor={theme.CreateFormTheme.colors.background}>Edit {formattedText(element.type)}</StyledText>
        </div>}
      </ElementToolbar>
      {renderElementContent()}
    </InnerElementWrapper>
  );
};

export default InnerElement;